import { Banner } from "@aurem/ui";
import { useBanner } from "./";

export const BannerStack = () => {
  const { banners } = useBanner();

  if (banners.length === 0) return null;

  return (
    <div className="sticky top-0 z-30">
      {banners.map((banner) => (
        <Banner
          key={banner.id}
          {...banner.props}
          variant={banner.props.variant || "bleed"}
        />
      ))}
    </div>
  );
};
